import { Field, Form, Formik } from "formik";
import { capitalize } from "lodash";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { object, string } from "yup";

import {
  reset_password,
  wipe_password_reset,
} from "shared/actions/authActions";

import { useAppDispatch, useAppSelector } from "app/hooks";
import { ApplicationState } from "app/store";
import LoginLayout from "ui/components/LoginLayout";

const ResetPasswordPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { detail, error } = useAppSelector(
    ({ passwordReset }: ApplicationState) => passwordReset
  );

  useEffect(() => {
    dispatch(wipe_password_reset());
  }, []);

  let schema = object().shape({
    email: string().email().required(),
  });

  return (
    <LoginLayout>
      <div className="LoginPage">
        <Formik
          initialValues={{ email: "" }}
          validationSchema={schema}
          validateOnChange={false}
          validateOnBlur={false}
          validate={() => dispatch(wipe_password_reset())}
          onSubmit={(values, { setSubmitting }) => {
            dispatch(reset_password(values));
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, errors }) => (
            <Form translate="yes">
              <div className="message_container">
                <h1>Enter your recovery email address</h1>
                <span>We will send a new code to reset your password.</span>
                {(error?.message || errors.email) && (
                  <div className="alert alert-danger">
                    {error?.message || capitalize(errors.email)}
                  </div>
                )}
                {detail && <div className="alert alert-success">{detail}</div>}
              </div>

              <Field
                type="email"
                name="email"
                id="email"
                placeholder="Password Reset Email"
                maxLength={150}
                required
              />
              <div className="mfa-form-buttons">
                <button
                  type="submit"
                  title="Send Request"
                  className="Button"
                  style={{ whiteSpace: "nowrap", width: "auto" }}
                  disabled={isSubmitting}
                >
                  Send Request
                </button>
                <button
                  type="button"
                  title="Back to Login"
                  className="Button--text"
                  style={{ whiteSpace: "nowrap", width: "auto" }}
                  disabled={isSubmitting}
                  onClick={() => navigate(-1)}
                >
                  Back to Login
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </LoginLayout>
  );
};

export default ResetPasswordPage;
